import { openUploadPersistence } from "./uploadPersistence";
import { createUploadManager } from "./uploadManager";
import { createS3MultipartTaskFactory } from "./s3MultipartUploadTask";
import { createUploadScheduler } from "./uploadScheduler";

let uploadManagerPromise = null;
const uploadScheduler = createUploadScheduler(4);

export function getUploadManager() {
  if (!uploadManagerPromise) {
    uploadManagerPromise = openUploadPersistence().then(db =>
      createUploadManager({
        db,
        taskFactory: createS3MultipartTaskFactory({
          db,
          scheduler: uploadScheduler
        })
      })
    );
  }
  return uploadManagerPromise;
}

export function resetUploadManagerForTests() {
  uploadManagerPromise = null;
}
